import { lazy, Suspense } from "react";
import CircularLoader from "../../../customs/loader/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/events/main"));

const Event = () => {
  return (
      
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default Event;

